module.exports = import("people");;